// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  jobId: __t.u64(),
  kind: __t.u8(),
  seed: __t.byteArray(),
  briefHash: __t.byteArray(),
  blob: __t.byteArray(),
  blobHash: __t.byteArray(),
  certificate: __t.byteArray(),
};
